import { Component, OnInit } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { FormBuilder } from "@angular/forms";

@Component({
  selector: "app-ask-us-form",
  templateUrl: "./ask-us-form.component.html",
  styleUrls: ["./ask-us-form.component.scss"],
})
export class AskUsFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private firestore: AngularFirestore
  ) {}
  submitted = false;
  askUsForm = this.formBuilder.group({
    name: "",
    email: "",
    message: "",
  });
  ngOnInit(): void {}

  onSubmit(): void {
    console.log();
  }

  sendMessage() {
    this.askUsForm.value["date"] = Date.now();
    this.firestore
      .collection("questions")
      .add(this.askUsForm.value)
      .then((e) => {
        this.askUsForm.reset();
        this.submitted = true;
      });
  }
}
